import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c00a7d04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "picture-holder" }

import { computed, PropType, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import CarouselPicture from "@/components/carousel-pictures/carousel-picture.vue";
import { PropertyImageType } from "acquaint-api/constants/PropertyImageType";
import { PictureIds } from "@/types/picture-management/picture-ids";
import { NavigationDirection } from "@/enums/system/NavigationDirection";
import { CarouselPictureType } from "@/enums/CarouselRecordType";


export default /*#__PURE__*/_defineComponent({
  __name: 'image-viewer-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },

  /**
   * The unique identifier for a property.
   * @type {string}
   * @required
   */
  recordId: {
    type: String,
    required: true,
  },

  /**
   * List of picture IDs representing the images related to the property.
   * @type {Array<PictureIds>}
   * @required
   */
  imageList: {
    type: Array as PropType<PictureIds[]>,
    required: true,
  },

  /**
   * The index of the image to be displayed initially.
   * @type {number}
   * @required
   */
  intialImageToDisplay: {
    type: Number,
    required: true,
  },
  /**
   * Determines the type of record the pictures belong to.
   */
  recordType: {
    type: Number as PropType<CarouselPictureType>,
    default: CarouselPictureType.Property,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showPopup = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const imageToDisplay = ref(0);

watch(
  () => showPopup.value,
  () => {
    if (!showPopup.value) {
      return;
    }

    imageToDisplay.value = props.intialImageToDisplay;
  },
);

const changePicture = (direction: NavigationDirection) => {
  // We need to find the index of the currently displayed image so we can find the next or previous
  // image in imageList
  let displayedImageIndex = props.imageList.findIndex(
    (image) => image.id == imageToDisplay.value,
  );

  switch (direction) {
    case NavigationDirection.Forwards:
      displayedImageIndex++;
      break;
    case NavigationDirection.Backwards:
      displayedImageIndex--;
  }

  // If the user is on the first image and tries to go to the previous image, we take them to the last image in the list.
  // Alternatively, if the user is on the last image and tries to go to the next image, we take them to the first image in the list.
  if (displayedImageIndex < 0) {
    displayedImageIndex = props.imageList.length - 1;
  } else if (displayedImageIndex > props.imageList.length - 1) {
    displayedImageIndex = 0;
  }

  imageToDisplay.value = props.imageList[displayedImageIndex].id;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showPopup.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showPopup).value = $event)),
    showCloseButton: true,
    title: "Image Viewer",
    height: "95vh",
    width: _unref(ModalWidth).Large,
    "show-close-confirmation-prompt": false,
    outsideShadingColour: "rgba(255,255,255,.5)"
  }, {
    "non-scrollable-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock(CarouselPicture, {
          key: imageToDisplay.value,
          "record-id": Number(props.recordId),
          "record-type": props.recordType,
          pictureNumber: imageToDisplay.value,
          type: _unref(PropertyImageType).PropertyImageWeb,
          "image-height": "100%",
          "object-fit": "contain"
        }, null, 8, ["record-id", "record-type", "pictureNumber", "type"]))
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Previous',
          onClick: () => {
            changePicture(_unref(NavigationDirection).Backwards);
          },
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Next',
          onClick: () => {
            changePicture(_unref(NavigationDirection).Forwards);
          },
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Close',
          onClick: () => {
            showPopup.value = false;
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})